import { CodeNodeDef } from "../../parser/definition/types/CodeNodeDef";
import { getCompilationTargetString } from "./getCompilationTarget";

export function getCodeNodeInputNames(node: CodeNodeDef<any, any>) {
    if (node.spreadInputNames && node.spreadInputNames.length > 0) {
        return { [getCompilationTargetString()]: `state.${node.spreadInputNames[0].toString()}` };
    }

    return node.inputNames.map((item) => item.toString());
}
